import React from "react";
import { cn } from "../../lib/cn";
import { Badge } from "./Badge";

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  actions,
  className,
  titleAs = "h2",
}) {
  return (
    <div
      className={cn(
        "w-full flex flex-col gap-4",
        align === "center" && "items-center text-center",
        className
      )}
    >
      {eyebrow && (
        <Badge variant="primary" className="uppercase tracking-wide">
          {eyebrow}
        </Badge>
      )}
      {title &&
        React.createElement(
          titleAs,
          { className: "font-display text-3xl md:text-4xl text-neutral-900" },
          title
        )}
      {description && (
        <p className="max-w-2xl text-neutral-600 text-base md:text-lg">
          {description}
        </p>
      )}
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
    </div>
  );
}


